import { Box, Button, Typography } from '@mui/material';
import ArrowBottom from '../../../../../components/Icons/Arrow-bottom';
import ExcelIcon from '../../../../../components/Icons/excel';
import { colors } from '../../../../../components/ThemeProvider/themeColors';

export default function ExcelExample() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        backgroundColor: colors.base[75],
        padding: '12px 16px',
        borderRadius: '8px',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <ExcelIcon sx={{ width: '36px', height: '36px' }} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 0.25,
          }}
        >
          <Typography fontSize={16} fontWeight={600} lineHeight='24px'>
            Əmək_haqqı_kartı.xlsx
          </Typography>
          <Typography fontSize={12} fontWeight={500} lineHeight='20px'>
            18 MB
          </Typography>
        </Box>
      </Box>
      <Button
        variant='contained'
        color='secondary'
        onClick={() => {
          window.open('/examples/Əmək_haqqı_kartı.xlsx');
        }}
      >
        <ArrowBottom />
        Yüklə
      </Button>
    </Box>
  );
}
